import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const useProvince = () => useQuery({ queryKey: ["province"], queryFn: async () => (await api.get("/province")).data, staleTime: Infinity });

export function ProvinciaSelect({ value, onChange, testid, emptyLabel = "Nessuna provincia", className, disabled }) {
  const { data: province = [] } = useProvince();
  return (
    <Select value={value || "__none__"} onValueChange={(v) => onChange(v === "__none__" ? "" : v)} disabled={disabled}>
      <SelectTrigger className={className} data-testid={testid}><SelectValue placeholder="Provincia" /></SelectTrigger>
      <SelectContent className="max-h-72">
        <SelectItem value="__none__">{emptyLabel}</SelectItem>
        {province.map((p) => <SelectItem key={p.sigla} value={p.sigla}>{p.nome} ({p.sigla})</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
